/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContestReportTemplate = {

	delete (context, templateId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest-report-template"
			+ "?templateId=" + templateId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteSchema (context, templateId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest-report-template/schema"
			+ "?templateId=" + templateId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-report-template/list"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSchema (context, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-report-template/schema"
			+ "?templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, departmentId, name, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest-report-template"
			+ "?departmentId=" + departmentId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, templateId, name, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest-report-template"
			+ "?templateId=" + templateId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSchema (context, saveAgencyContestTemplateSchemaDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest-report-template/schema"
			, saveAgencyContestTemplateSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
